export const INIT_JIRA_APP = 'init-jira-app'
export const INIT_JIRA_WIDGET = 'init-jira-widget'
export const INIT_JIRA_GADGET = 'init-jira-gadget'
export const INIT_CONFLUENCE_MACRO = 'init-confluence-macro'
export const INIT_CONFLUENCE_MACRO_SETTINGS = 'init-confluence-macro-settings'
export const INIT_CONFLUENCE_GLOBAL_SETTINGS = 'init-confluence-global-settings'
export const CONFLUENCE_GLOBAL_SETTINGS_TOKEN_STATUS = 'get-token-status'
export const CONFLUENCE_GLOBAL_SETTINGS_SAVE_TOKEN = 'save-token'

// Web trigger key
export const OBOARD_WEB_TRIGGER = 'oboard-web-trigger'

// Http headers
export const AUTH_HEADER = 'authorization'
export const AUTH_HEADER_PREFIX = 'Bearer'
